import { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      data-testid="scroll-to-top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Scroll to top"
      className="fixed bottom-6 left-6 z-40 w-11 h-11 rounded-full bg-white border border-[#E7E9EC] shadow-[0_4px_20px_rgba(0,0,0,0.08)] flex items-center justify-center text-[#5A6376] hover:text-brand-teal hover:border-brand-teal/30 transition-all duration-300"
    >
      <ArrowUp size={18} strokeWidth={1.5} />
    </button>
  );
}
